module.exports = __webpack_public_path__ + "img/bny-detail-1.0518c759.png";